import dayjs from 'dayjs';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class CompareUtils {
  public static compareById(a: any, b: any) {
    return a.id === b.id;
  }

  public static compareBoolean(a: boolean | undefined, b: boolean | undefined): number {
    if (a !== undefined && b !== undefined) {
      return a > b ? 1 : -1;
    } else {
      return 0;
    }
  }

  public static safeLocaleCompare(a: string | undefined, b: string | undefined): number {
    if (!a) {
      return -1;
    }
    if (!b) {
      return +1;
    }
    return a.localeCompare(b);
  }

  public static compareDateStrings(a: string | undefined, b: string | undefined): number {
    if (a && b) {
      return dayjs(a).isAfter(b) ? 1 : -1;
    } else {
      return 0;
    }
  }

  public static compareDates(a: Date | undefined, b: Date | undefined): number {
    if (a && b) {
      return dayjs(a).isAfter(b) ? 1 : -1;
    } else {
      return 0;
    }
  }

  public static compareByUsername(a: any, b: any) {
    return a.username === b.username;
  }

  public static compareNumber(a: number | undefined, b: number | undefined): number {
    if (!a) {
      return -1;
    }
    if (!b) {
      return +1;
    }
    return a > b ? 1 : -1;
  }
}
